const generateRandomColor = () => {
  const randomColor = Math.floor(Math.random() * 16777215)
    .toString(16)
    .padStart(6, "0");
  return `#${randomColor}`;
};

const generateRandomDarkColor = () => {
  const r = Math.floor(Math.random() * 100); // 0–99
  const g = Math.floor(Math.random() * 100);
  const b = Math.floor(Math.random() * 100);

  const toHex = (n: number) => n.toString(16).padStart(2, "0");

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

const generateColorFromEmail = (email: string) => {
  let hash = 0;
  for (let i = 0; i < email.length; i++) {
    hash = email.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash) % 360; // 0–359
  const saturation = 60; // stay vivid but not neon
  const lightness = 30; // dark range

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

export { generateRandomColor, generateColorFromEmail };
